import React from "react";

import {
  ValueField,
  ZoomCoefficientValueField,
} from "../../ValueFields/ValueFields";
import { Heading3 } from "../../Headings/Headings";

const PsoriasisSegmentationCalculatedResults = (props) => {
  const { calculationProgress, psoriasisSegmentationCalculationData } = props;

  const { calculationSuccessful = false } = calculationProgress;

  const {
    classificationZC = 0.5,
    semanticZC = 0.5,

    // # Affected Percentages of whole body, front and back images.
    affectedPercentageBody = 0,
    affectedPercentageFront = 0,
    affectedPercentageBack = 0,

    // # Overall PASI score
    pasiScore = 0,

    // # Data for standard PASI Scoring.
    // # 1: Head.
    headAffectedPercentage = 0,
    headAreaScore = 0,
    headSegmentScore = 0,
    headErythema = 0,
    headInduration = 0,
    headDesquamation = 0,

    // # 2: Torso / Trunk.
    torsoAffectedPercentage = 0,
    torsoAreaScore = 0,
    torsoSegmentScore = 0,
    torsoErythema = 0,
    torsoInduration = 0,
    torsoDesquamation = 0,

    // # 3: Arms / Upper Extremities.
    armsAffectedPercentage = 0,
    armsAreaScore = 0,
    armsSegmentScore = 0,
    armsErythema = 0,
    armsInduration = 0,
    armsDesquamation = 0,

    // # 4: Legs / Lower Extremities.
    legsAffectedPercentage = 0,
    legsAreaScore = 0,
    legsSegmentScore = 0,
    legsErythema = 0,
    legsInduration = 0,
    legsDesquamation = 0,
  } = psoriasisSegmentationCalculationData;

  return (
    // TODO: Create nicer transition
    <div
      className="flex flex-col w-full overflow-hidden Xbg-red-500"
      style={
        calculationSuccessful
          ? { height: "100%" }
          : { height: "0", padding: "0", margin: "0" }
      }
    >
      <div className="py-2" />

      <Heading3 headingText={"Calculation Results"} />

      <div className="py-1" />

      <div className="overflow-x-scroll">
        <div className="flex flex-col w-full min-w-[60rem]">
          <div className="flex flex-row w-full">
            <ValueField value={""} />
            <div className="px-1" />
            <ValueField value={"Affected"} />
            <div className="px-1" />
            <ValueField value={"Area Score"} />
            <div className="px-1" />
            <ValueField value={"Erythema"} />
            <div className="px-1" />
            <ValueField value={"Induration"} />
            <div className="px-1" />
            <ValueField value={"Desquamation"} />
            <div className="px-1" />
            <ValueField value={"Score"} />
          </div>
          <div className="py-1" />
          <div className="flex flex-row w-full">
            <ValueField value={"Head"} />
            <div className="px-1" />
            <ValueField
              value={`${Number(headAffectedPercentage).toFixed(2)} %`}
            />
            <div className="px-1" />
            <ValueField value={headAreaScore} />
            <div className="px-1" />
            <ValueField value={headErythema} />
            <div className="px-1" />
            <ValueField value={headInduration} />
            <div className="px-1" />
            <ValueField value={headDesquamation} />
            <div className="px-1" />
            <ValueField value={Number(headSegmentScore).toFixed(2)} />
          </div>
          <div className="py-1" />
          <div className="flex flex-row w-full">
            <ValueField value={"Arms"} />
            <div className="px-1" />
            <ValueField
              value={`${Number(armsAffectedPercentage).toFixed(2)} %`}
            />
            <div className="px-1" />
            <ValueField value={armsAreaScore} />
            <div className="px-1" />
            <ValueField value={armsErythema} />
            <div className="px-1" />
            <ValueField value={armsInduration} />
            <div className="px-1" />
            <ValueField value={armsDesquamation} />
            <div className="px-1" />
            <ValueField value={Number(armsSegmentScore).toFixed(2)} />
          </div>
          <div className="py-1" />
          <div className="flex flex-row w-full">
            <ValueField value={"Torso"} />
            <div className="px-1" />
            <ValueField
              value={`${Number(torsoAffectedPercentage).toFixed(2)} %`}
            />
            <div className="px-1" />
            <ValueField value={torsoAreaScore} />
            <div className="px-1" />
            <ValueField value={torsoErythema} />
            <div className="px-1" />
            <ValueField value={torsoInduration} />
            <div className="px-1" />
            <ValueField value={torsoDesquamation} />
            <div className="px-1" />
            <ValueField value={Number(torsoSegmentScore).toFixed(2)} />
          </div>
          <div className="py-1" />
          <div className="flex flex-row w-full">
            <ValueField value={"Legs"} />
            <div className="px-1" />
            <ValueField
              value={`${Number(legsAffectedPercentage).toFixed(2)} %`}
            />
            <div className="px-1" />
            <ValueField value={legsAreaScore} />
            <div className="px-1" />
            <ValueField value={legsErythema} />
            <div className="px-1" />
            <ValueField value={legsInduration} />
            <div className="px-1" />
            <ValueField value={legsDesquamation} />
            <div className="px-1" />
            <ValueField value={Number(legsSegmentScore).toFixed(2)} />
          </div>
          <div className="py-2" />
          <div className="flex flex-row w-full">
            <ValueField value={"Front Affected"} />
            <div className="px-1" />
            <ValueField value={"Back Affected"} />
            <div className="px-1" />
            <ValueField value={"Body Affected"} />
            <div className="px-1" />
            <ValueField value={"PASI Score"} />
          </div>
          <div className="py-1" />
          <div className="flex flex-row w-full">
            <ValueField
              value={`${Number(affectedPercentageFront).toFixed(2)}%`}
            />
            <div className="px-1" />
            <ValueField
              value={`${Number(affectedPercentageBack).toFixed(2)}%`}
            />
            <div className="px-1" />
            <ValueField
              value={`${Number(affectedPercentageBody).toFixed(2)}%`}
            />
            <div className="px-1" />
            <ValueField value={Number(pasiScore).toFixed(2)} />
          </div>
          <div className="py-2" />
          <div className="flex flex-row w-full">
            <ZoomCoefficientValueField
              name={"Semantic Zoom Coefficient"}
              value={Number(semanticZC).toFixed(2)}
            />
            <div className="px-1" />
            <ZoomCoefficientValueField
              name={"Classification Zoom Coefficient"}
              value={Number(classificationZC).toFixed(2)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PsoriasisSegmentationCalculatedResults;
